module.exports = __webpack_public_path__ + "static/media/group-29-copy.80beb71e.svg";